// extracted by mini-css-extract-plugin
module.exports = {"burger":"Header-module--burger--vWi6E","burgers":"Header-module--burgers--1L985"};